import { CheckrStatusResults } from '../../../../../../constants'

export function isProgressCheckStep(application, options) {
  const { isAtCapacity } = options
  const { dasherId, dateOfBirth, backgroundCheckResults } = application
  const hasDasher = !!dasherId
  const hasDob = !!dateOfBirth

  return (
    hasDasher &&
    hasDob &&
    !isAtCapacity &&
    backgroundCheckResults !== CheckrStatusResults.Skipped
  )
}
